import React, { FC } from "react";
import { useStockStatisticDetailModel } from "./statisticDetailModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useDictModel } from "../../../../base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const PageHeader: FC<RouterParamType> = ({ id, mode }) => {
    const { getSelectedDictOne } = useDictModel();
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useStockStatisticDetailModel();

    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale, warehouseList } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const searchFields = [
        {
            type: SearchTypeEnum.Select,
            // placeholder: "出入类型",
            placeholder: Locale["Stock-io Type"],
            fieldName: "ioFlag",
            options: [{ label: Locale["Stock in order"], value: 1 }, { label: Locale["Outbound order"], value: 0 }]
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "单据类型",
            placeholder: Locale["Document  Type"],
            fieldName: "tradeTypeCode",
            options: getSelectedDictOne(DictCodeEnmu.TRADE_TYPE)
        },
        {
            type: SearchTypeEnum.Input,
            // placeholder: "单据编号",
            placeholder: Locale["Document No."],
            fieldName: "tradeCode",
            options: transOptions(warehouseList)
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            // placeholder: ["制单日期起始", "制单日期结束"],
            placeholder: [Locale["CreationStartTime"], Locale["CreationEndTime"]],
            rangePickerFieldName: ["startTime", "endTime"],
            showTime: true,
            span: 16,
            xxl: 8,
        },
    ]
    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Warehouse Management"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Statistics Details"]}</span>
    </>
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={() => resetSearchParam(id)}
        />
    );
}